<template>
  <UiButton
    type="button"
    severity="tertiary"
    class="overflow-hidden whitespace-nowrap"
    :active="!inactive && !!value"
  >
    <div class="relative flex items-center gap-1 text-sm">
      <template v-if="!inactive && value">
        <template v-if="Array.isArray(value)">
          <UiDate :value="value[0]" template="d MMM" /> —
          <UiDate :value="value[1]" template="d MMM" />
        </template>
        <template v-else>
          <UiDate :value="value" template="d MMM" />
        </template>
        <UiIcon name="x-mark" class="size-5" @click.stop="emit('reset')" />
      </template>
      <template v-if="!value">
        <slot v-if="!disableIcon" name="icon">
          <UiIcon name="calendar" class="size-5 min-w-5 text-icon-primary" />
        </slot>
        <template v-else> <slot>выбрать дату</slot> </template>
      </template>
    </div>
  </UiButton>
</template>

<script setup lang="ts">
import UiButton from '../UiButton.vue'
import UiDate from '../UiDate.vue'
import UiIcon from '../UiIcon.vue'

type PropType = {
  value?: Date | Date[]
  inactive?: boolean
  disableIcon?: boolean
}
type EmitType = {
  (e: 'reset'): void
}

withDefaults(defineProps<PropType>(), {
  value: undefined,
  inactive: false,
  disableIcon: false
})
const emit = defineEmits<EmitType>()
</script>
